import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import RouteContext from 'src/routes/context';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { setSelectedSizeVariants } from 'src/areas/product/actions/product';
import { VariantValues } from 'src/types';
import { SizeVariants } from './size-variants';
import { createNewSelection } from './size-variants/utils';

export const Variants: React.FC<IVariants> = ({ variants }) => {
  const { dispatch: routeDispatch } = useContext(RouteContext);
  const dispatch = useDispatch();
  const { filters, selectedCondition, selectedSizeVariants } = useContext(
    PriceListFilterContext
  );
  const hasSizeVariants = (variants?.sizes?.length || 0) > 0;

  const handleSelection = (variant: string | null) => {
    const newSelection = createNewSelection(variant, selectedSizeVariants);
    dispatch(setSelectedSizeVariants(newSelection));
    routeDispatch({
      type: 'PRODUCT_SIZE_VARIANTS',
      variantSizes: newSelection,
      options: { ...filters },
      condition: selectedCondition,
    });
  };

  return (
    <>
      {hasSizeVariants && (
        <SizeVariants handleSelection={handleSelection} variants={variants} />
      )}
    </>
  );
};

interface IVariants {
  variants: VariantValues;
}
